import React, { useEffect, useState } from "react";
import icon_amenities from "../../images/icon_amenities.png";
import icon_services from "../../images/icon_services.png";
import { Fade } from "react-awesome-reveal";
import { useRoomContext } from "../../context/RoomContext";
import { marked } from "marked";
// import { Element } from "react-scroll";

const RoomService = (props: { id: number }) => {
  const { roomData } = useRoomContext();
  const filterRoomData = roomData.filter((room) => room?.id === props.id);
  const [roomAmenities, setRoomAmenities] = useState<string>("");
  const [roomService, setRoomService] = useState<string>("");

  useEffect(() => {
    const loadMarkdown = async () => {
      const amenities = filterRoomData[0]?.attributes?.Amenities || "";
      const service = filterRoomData[0]?.attributes?.Services || "";
      const processedAmenities = await marked(amenities);
      const processedService = await marked(service);
      setRoomAmenities(processedAmenities);
      setRoomService(processedService);
    };

    loadMarkdown();
  }, [filterRoomData]);
  return (
    <>
      <div id="singleroom_amenities" className="singleroom_amenities">
        <Fade direction="up" triggerOnce={true}>
          {/* <div className="page_content_wrapper custom-page_content_wrapper"> */}
          <div className="custom-page_content_wrapper">
            <div className="singleroom_amenities_wrapper">
              <div className="singleroom_amenities_content">
                <div className="singleroom_amenities_label">
                  <img src={icon_amenities} alt="Amenities" />
                  Amenities
                </div>
                <div className="singleroom_amenities_list_wrapper">
                  {/* <ul className="singleroom_amenities_list">
                    <li>40-inch Samsung® LED TV</li>
                    <li>Electronic safe with charging facility</li>
                    <li>iHome™ Bluetooth MP3 Player</li>
                    <li>Iron and ironing board</li>
                    <li>Mini bar</li>
                    <li>Non-smoking</li>
                    <li>USB charging station</li>
                    <li>Wired and wireless broadband Internet access</li>
                    <li>Work desk</li>
                  </ul> */}
                  <div className="singleroom_amenities_list" dangerouslySetInnerHTML={{ __html: roomAmenities }} />
                </div>
              </div>
              <br className="clear" />
            </div>

            <div className="singleroom_amenities_wrapper">
              <div className="singleroom_amenities_content">
                <div className="singleroom_amenities_label">
                  <img src={icon_services} alt="Services" />
                  Services
                </div>
                <div className="singleroom_amenities_list_wrapper">
                  {/* <ul className="singleroom_amenities_list">
                    <li>
                      Free-to-use smartphone&nbsp;(
                      <span className="mphb-price mphb-price-free">Free</span> )
                    </li>
                    <li>
                      Safe-deposit box&nbsp;(
                      <span className="mphb-price mphb-price-free">Free</span> )
                    </li>
                    <li>
                      Luggage storage&nbsp;(
                      <span className="mphb-price mphb-price-free">Free</span> )
                    </li>
                    <li>
                      Childcare&nbsp;(
                      <span className="mphb-price">
                        <span className="mphb-currency">&#036;</span>60
                      </span>{" "}
                      / Once / Per Accommodation )
                    </li>
                    <li>
                      Massage&nbsp;(
                      <span className="mphb-price">
                        <span className="mphb-currency">&#036;</span>15
                      </span>{" "}
                      / Once / Per Guest )
                    </li>
                  </ul> */}
                  <div className="singleroom_amenities_list" dangerouslySetInnerHTML={{ __html: roomService }} />
                </div>
              </div>
              <br className="clear" />
            </div>
          </div>
        </Fade>
      </div>
    </>
  );
};

export default RoomService;
